import { TempeFabricationPublicServiceException as __BaseException } from "./TempeFabricationPublicServiceException";
export const AttributionEventType = {
    PRODUCT_ADDED_TO_CART: "PRODUCT_ADDED_TO_CART",
};
export class InvalidInput extends __BaseException {
    name = "InvalidInput";
    $fault = "client";
    error;
    constructor(opts) {
        super({
            name: "InvalidInput",
            $fault: "client",
            ...opts
        });
        Object.setPrototypeOf(this, InvalidInput.prototype);
        this.error = opts.error;
    }
}
export class ProductUnavailable extends __BaseException {
    name = "ProductUnavailable";
    $fault = "client";
    error;
    productId;
    constructor(opts) {
        super({
            name: "ProductUnavailable",
            $fault: "client",
            ...opts
        });
        Object.setPrototypeOf(this, ProductUnavailable.prototype);
        this.error = opts.error;
        this.productId = opts.productId;
    }
}
export class ValidationException extends __BaseException {
    name = "ValidationException";
    $fault = "client";
    fieldList;
    constructor(opts) {
        super({
            name: "ValidationException",
            $fault: "client",
            ...opts
        });
        Object.setPrototypeOf(this, ValidationException.prototype);
        this.fieldList = opts.fieldList;
    }
}
export const OrderStatus = {
    CANCELLED: "CANCELLED",
    DELIVERED: "DELIVERED",
    ORDER_PLACED: "ORDER_PLACED",
    PACKING: "PACKING",
    PARTIALLY_SHIPPED: "PARTIALLY_SHIPPED",
    PROCESSING: "PROCESSING",
    SHIPPED: "SHIPPED",
};
export const ShippingOptionType = {
    EXPEDITED: "EXPEDITED",
    NEXT_DAY: "NEXT_DAY",
    STANDARD: "STANDARD",
};
export class InvalidAddressException extends __BaseException {
    name = "InvalidAddressException";
    $fault = "client";
    error;
    possibleAddresses;
    constructor(opts) {
        super({
            name: "InvalidAddressException",
            $fault: "client",
            ...opts
        });
        Object.setPrototypeOf(this, InvalidAddressException.prototype);
        this.error = opts.error;
        this.possibleAddresses = opts.possibleAddresses;
    }
}
export const SaleType = {
    AMOUNT: "AMOUNT",
    PERCENT: "PERCENT",
};
export const ProductStatus = {
    AVAILABLE: "AVAILABLE",
    BACK_ORDERED: "BACK_ORDERED",
    DISCONTINUED: "DISCONTINUED",
    LIMITED_INVENTORY: "LIMITED_INVENTORY",
    OUT_OF_STOCK: "OUT_OF_STOCK",
};
export class NoSuchResource extends __BaseException {
    name = "NoSuchResource";
    $fault = "client";
    resource;
    constructor(opts) {
        super({
            name: "NoSuchResource",
            $fault: "client",
            ...opts
        });
        Object.setPrototypeOf(this, NoSuchResource.prototype);
        this.resource = opts.resource;
    }
}
